"use client";

import { ChevronRight } from "lucide-react";
import type { ReactNode } from "react";
import { cn } from "../../lib/utils";
import { BottomSheet } from "./bottom-sheet";

export type PostStudioPlatformOption<T extends string = string> = {
  id: T;
  label: string;
  helperText: string;
  icon: ReactNode;
  iconWrapperClassName?: string;
};

export type PostStudioPlatformSheetProps<T extends string = string> = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  subtitle: string;
  options: PostStudioPlatformOption<T>[];
  onChoosePlatform: (platform: T) => void;
};

export function PostStudioPlatformSheet<T extends string = string>({
  isOpen,
  onClose,
  title,
  subtitle,
  options,
  onChoosePlatform,
}: PostStudioPlatformSheetProps<T>) {
  return (
    <BottomSheet
      isOpen={isOpen}
      onClose={onClose}
      className="bg-[#FFF9EF] px-4 pb-6 pt-4 shadow-[0_-12px_76px_rgba(0,0,0,0.16)]"
      contentClassName="max-w-none"
      title={
        <div className="space-y-1">
          <p className="text-xl font-semibold text-[#344054]">{title}</p>
          <p className="text-sm font-normal leading-6 text-[#667085]">{subtitle}</p>
        </div>
      }
    >
      <div className="space-y-4">
        <div className="space-y-2">
          {options.map((option) => (
            <button
              key={option.id}
              type="button"
              onClick={() => onChoosePlatform(option.id)}
              className="flex w-full items-center justify-between rounded-xl border border-black bg-white px-4 py-4 text-left shadow-[0px_4px_0px_0px_#000000]"
            >
              <div className="flex min-w-0 items-center gap-3">
                <span
                  className={cn(
                    "flex h-10 w-10 shrink-0 items-center justify-center rounded-full",
                    option.iconWrapperClassName
                  )}
                >
                  {option.icon}
                </span>
                <span className="min-w-0">
                  <span className="block text-base font-semibold text-[#344054]">{option.label}</span>
                  <span className="mt-1 block text-xs font-normal leading-5 text-[#667085]">
                    {option.helperText}
                  </span>
                </span>
              </div>
              <ChevronRight className="h-5 w-5 text-[#98A2B3]" />
            </button>
          ))}
        </div>
      </div>
    </BottomSheet>
  );
}

